import {CommonMessages} from '../common.messages';

export const PanelReportsReferredAccountsMessages = { 
    ExportReportFailed: {
        key: 'ExportReportFailed',
        message: 'Error while communication with the server. Unable to export report.'
    },
    ExportReportRequested: {
        key: 'ExportReportRequested',
        message: 'Export request has been sent to the server.'
    },
    GetReportFailed: {
        key: 'GetReportFailed',
        message: 'Error while communication with the server. Unable to get Referral report.'
    },
    NotFoundExportData: {
        key: 'NotFoundExportData',
        message: 'Error while communication with the server. Can\'t find data to export.'
    }, 
    WrongDateTo: {
        key: 'WrongDateTo',
        message: 'Date To must be greater than Date From'
    },
    ReferralCodeRequired: {
        key: 'ReferralCodeRequired',
        message: 'Referral Code is required'
    },
    ...CommonMessages
};
